export const npsKeys = {
    lastScore: () => ['nps'],
};
